import { ILineBreakBehavior } from "./ILineBreakBehavior";

export interface ILineBreakBehaviorSpecifiable {
  lineBreakBehavior: ILineBreakBehavior;
}

export function instanceOfILineBreakBehaviorSpecifiable(instance: any): instance is ILineBreakBehaviorSpecifiable {
  return instance
      && (instance.lineBreakBehavior !== undefined);
}
